
// Returns a point by its original index, before sorting by date.
export default function getPoint(series, index) {
  let point = series.data[index];
  series.data.some((item, i) => {
    if (item.index === index) {
      point = item;
      return true;
    }
  });
  return point;
}



// WEBPACK FOOTER //
// ./src/chart/data/getPoint.js